// extracted by mini-css-extract-plugin
export var defaultWrapper = "_i5-3";
export var downloadButton = "_i5-4";
export var fileContainer = "_i5-9 _i5-7";
export var fileContainerBase = "_i5-7";
export var fileContainerFixedHeight = "_i5-8 _i5-7";
export var fileInfo = "_i5-5";
export var fileInfoWidthRestricted = "_i5-6";
export var fileType = "_i5-1";
export var fileTypeName = "_i5-2";
export var image = "_i5-0";
export var link = "_i5-b";
export var overflowEllipsis = "_i5-a";